import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ToastMessageService } from '../../../widgets/toast-message/toast-message.service';
import { ApiService } from '../../../services/api.service';
import { FormService } from 'src/app/services/form.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-edit-custom-item-form',
  templateUrl: './edit-custom-item-form.component.html',
  styleUrls: ['./edit-custom-item-form.component.scss']
})
export class EditCustomItemFormComponent implements OnInit {

  @Input() id: string;
  @Output() formSaved: EventEmitter<any> = new EventEmitter<any>();

  private ciEndpoint = `${this.apiSvc.endpoints.catalog}/api/CustomItemDefHead`;

  constructor(
    private apiSvc: ApiService,
    private formSvc: FormService,
    private router: Router,
    private toastMsgSvc: ToastMessageService,
    private utilsSvc: UtilitiesService
  ) {}

  viewReady = false;

  // form model
  model: any = {
    Id: null,
    CustomItemDefHeadCode: null,
    CustomHeadDescription: null,
    StartDate: this.utilsSvc.todaysDate,
    EndDate: null,
  };

  // messages
  fieldErrors: any = {};
  formErrors: any = null;

  // form config
  formProcessing = false;

  /**
   * Process add record form
   * @param {object} e
   * @param {object} form
   */
  onSubmit(e: object, form: object): void {

    e['preventDefault']();

    // if form is invalid, return
    if (!form['valid'] || this.formProcessing) {
      return;
    }

    // clear errors
    this.formErrors = null;
    this.fieldErrors = {};

    // set form to processing to prevent double submissions and show spinner
    this.formProcessing = true;

    const params = this.model;

    const action = this.model['Id'] ? 'update' : 'add';
    const endpoint = this.model['Id'] ? `${this.ciEndpoint}/${this.model['Id']}` : this.ciEndpoint;

    // add record via service
    this.apiSvc[action](endpoint, params)
      .subscribe((res) => {

        this.formProcessing = false;

        // show success message
        this.toastMsgSvc.send({
          icon: 'check_circle_outline',
          message: 'Custom Item Group saved',
          type: 'success'
        });

        // on success, redirect to edit
        if (action === 'add' && res && res['Id']) {
          this.router.navigate([`/merchandising/custom-items/${res['Id']}`]);
        }

      }, (err) => {

        const errors = this.formSvc.processFormErrors(err);

        if (errors.formErrors) {
          this.formErrors = errors.formErrors;
        }

        if (errors.fieldErrors) {
          this.fieldErrors = errors.fieldErrors;
        }

        this.formProcessing = false;

      });

  }

  /**
   * Get custom item data
   */
  getCustomItem(): void {

    // if there is not a record id
    if (!this.id) {
      this.viewReady = true;
      return;
    }

    this.apiSvc.get(`${this.ciEndpoint}/${this.id}`)
      .subscribe((res) => {
        if (res) {
          this.model = res;
          setTimeout(() => {
            this.viewReady = true;
          }, 50);
        }
      }, (err) => {
        console.log(err);
        this.viewReady = true;
      });

  }

  ngOnInit() {
    this.getCustomItem();
  }

}
